<template>
  <div v-loading="loading">
    <el-card>
      <el-descriptions title="合同基础信息" size="medium">
        <el-descriptions-item label="合同编号">{{ cp.contract }}</el-descriptions-item>
        <el-descriptions-item label="合同起止时间" :span="2">{{ copyrightDateRangeText }}</el-descriptions-item>
        <el-descriptions-item label="专辑数量">{{ cp.albumCount }} 张</el-descriptions-item>
        <el-descriptions-item label="歌曲数量">{{ cp.trackCount }} 首</el-descriptions-item>
        <el-descriptions-item label="艺人数量">{{ cp.singerCount }} 位</el-descriptions-item>
        <el-descriptions-item label="瑕疵歌曲数量">{{ cp.cpDefectCount }} 首</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card header="合同关联歌曲信息" class="m-t-lg">
      <relate-track-list :contract="contract"></relate-track-list>
    </el-card>
  </div>
</template>

<script>
import contractService from '@/api/contract'
import RelateTrackList from './components/RelateTrackList.vue'

function defaultContract() {
  return {
    albumCount: 0,
    contract: '',
    copyrightId: 0,
    originalCopyrightFrom: void (0),
    originalCopyrightTo: void (0),
    cpDefectCount: 0,
    singerCount: 0,
    trackCount: 0
  }
}

export default {
  name: 'ContractDetail',
  components: {
    RelateTrackList,
  },
  data() {
    return {
      loading: false,
      cp: defaultContract(),
      contract: this.$route.query.contract
    }
  },
  computed: {
    copyrightDateRangeText() {
      const from = this.cp.originalCopyrightFrom
      const to = this.cp.originalCopyrightTo
      if (!from && !to) return '-'
      return `${from} ~ ${to}`
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      if (!this.contract) return this.$message.error('合同编号不能为空')

      this.loading = true
      try {
        const res = await contractService.find({
          contract: this.contract
        })
        if (!res || !res.list || !res.list.length) throw new Error('合同不存在')
        this.cp = res.list[0]
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error',
          error
        })
      }
      this.loading = false
    }
  }
}
</script>
